import { render } from "./add_bom.vue?vue&type=template&id=7253e3d2&scoped=true"
import script from "./add_bom.vue?vue&type=script&lang=js"
export * from "./add_bom.vue?vue&type=script&lang=js"

import "./add_bom.vue?vue&type=style&index=0&id=7253e3d2&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7253e3d2"]])

export default __exports__